import { TenantEntity } from '../TenantEntity'

export class ShippingTermOperationType extends TenantEntity {
  constructor(data) {
    super(data)
  }

  get lob() {
    return this._data.lob
  }
  set lob(lob) {
    this._data.lob = lob || ''
  }
  get containerLoadType() {
    return this._data.containerLoadType
  }
  set containerLoadType(containerLoadType) {
    this._data.containerLoadType = containerLoadType || ''
  }
  get mbl() {
    return this._data.mbl
  }
  set mbl(mbl) {
    this._data.mbl = mbl || false
  }
  get shippingTermUuid() {
    return this._data.shippingTermUuid
  }
  set shippingTermUuid(shippingTermUuid) {
    this._data.shippingTermUuid = shippingTermUuid || null
  }
  get deleted() {
    return this._data.deleted
  }
  set deleted(deleted) {
    this._data.deleted = deleted || false
  }
}
